import React from "react";
import { ModalCrosSvg } from "../../../images/Svgs";
import { formatAMPM, formatDate } from "../../../utils/common";
const RoutineDetail = ({ openDetailModal, RoutineDetail, EventDetail }) => {
  console.log(' {row?.type === "routine" ? ', RoutineDetail);

  return (
    <div className="modal fade show">
      <div className="modal-dialog add_new_event_box">
        <div className="modal-content event_scroll">
          <div className="modal-header">
            <h1 className="modal-title fs-5 font-18" id="exampleModalLabel">
              {EventDetail?.event_title}
            </h1>
            <button
              type="button"
              className="new_event_lose inter"
              onClick={() => openDetailModal(false)}
            >
              <ModalCrosSvg />
            </button>
          </div>
          <div class="modal-body">
            <div>
              <p>
                {EventDetail?.event_date
                  ? formatDate(EventDetail?.event_date)
                  : "-"}{" "}
                at{" "}
                {EventDetail?.event_time_from
                  ? formatAMPM(EventDetail?.event_time_from)
                  : "-"}
              </p>
              <p>
                {EventDetail?.event_location
                  ? EventDetail?.event_location
                  : "-"}
              </p>
            </div>
            <div class="studio_name">
              <div class="performers">
                <div class="day_time">
                  <div class="entry_title">
                    <p style={{width:'100%'}}>Date</p>
                  </div>
                  <div class="small_group">
                    <p>
                      {RoutineDetail?.event_date
                        ? formatDate(RoutineDetail?.event_date)
                        : "-"}
                    </p>
                  </div>
                </div>
                <div class="day_time">
                  <div class="entry_title">
                    <p >Ceremony</p>
                  </div>
                  <div class="small_group">
                    <p>
                      {RoutineDetail?.ceremony ? RoutineDetail?.ceremony : "-"}
                    </p>
                  </div>
                </div>
                <div class="day_time">
                  <div class="entry_title">
                    <p >Day / Time</p>
                  </div>
                  <div class="small_group">
                    <p>
                      {RoutineDetail?.event_time_from
                        ? formatAMPM(RoutineDetail?.event_time_from)
                        : "-"}
                    </p>
                  </div>
                </div>
                {RoutineDetail?.type === "routine" && (
                  <>
                    <div class="day_time">
                      <div class="entry_title">
                        <p>Entry</p>
                      </div>
                      <div class="small_group">
                        <p>
                          {RoutineDetail?.entry ? RoutineDetail?.entry : "-"}
                        </p>
                      </div>
                    </div>
                    <div class="day_time">
                      <div class="entry_title">
                        <p>Performers</p>
                      </div>
                      <div class="small_group">
                        <p>
                          {RoutineDetail?.performers
                            ? RoutineDetail?.performers
                            : "-"}
                        </p>
                      </div>
                    </div>
                    <div class="day_time">
                      <div class="entry_title">
                        <p>Entry Division</p>
                      </div>
                      <div class="small_group">
                        <p>
                          {RoutineDetail?.masterEntryDivision?.name
                            ? RoutineDetail?.masterEntryDivision?.name
                            : "-"}
                        </p>
                      </div>
                    </div>
                    <div class="day_time">
                      <div class="entry_title">
                        <p>Title</p>
                      </div>
                      <div class="small_group">
                        <p>
                          {RoutineDetail?.title ? RoutineDetail?.title : "-"}
                        </p>
                      </div>
                    </div>
                    <div class="day_time">
                      <div class="entry_title">
                        <p>Entry Title</p>
                      </div>
                      <div class="small_group">
                        <p>
                          {RoutineDetail?.entry_title
                            ? RoutineDetail?.entry_title
                            : "-"}
                        </p>
                      </div>
                    </div>
                  </>
                )}
              </div>
              {RoutineDetail?.type === "routine" && (
                <div class="performers">
                  <div class="day_time">
                    <div class="entry_title">
                      <p>Category</p>
                    </div>
                    <div class="small_group">
                      <p>
                        {RoutineDetail?.masterMusicCategory?.name
                          ? RoutineDetail?.masterMusicCategory?.name
                          : "-"}
                      </p>
                    </div>
                  </div>
                  <div class="day_time">
                    <div class="entry_title">
                      <p>Studio Name</p>
                    </div>
                    <div class="small_group">
                      <p>
                        {RoutineDetail?.studio_name
                          ? RoutineDetail?.studio_name
                          : "-"}
                      </p>
                    </div>
                  </div>

                  <div class="day_time">
                    <div class="entry_title">
                      <p>Studio Code</p>
                    </div>
                    <div class="small_group">
                      <p>
                        {RoutineDetail?.studio_code
                          ? RoutineDetail?.studio_code
                          : "-"}
                      </p>
                    </div>
                  </div>
                  <div class="day_time">
                    <div class="entry_title">
                      <p>Age Class</p>
                    </div>
                    <div class="small_group">
                      <p>
                        {RoutineDetail?.masterAgeClass?.name
                          ? RoutineDetail?.masterAgeClass?.name
                          : "-"}
                      </p>
                    </div>
                  </div>
                  <div class="day_time">
                    <div class="entry_title">
                      <p>Entry Age</p>
                    </div>
                    <div class="small_group">
                      <p>
                        {RoutineDetail?.entry_age
                          ? RoutineDetail?.entry_age
                          : "-"}
                      </p>
                    </div>
                  </div>
                  <div class="day_time">
                    <div class="entry_title">
                      <p>Level</p>
                    </div>
                    <div class="small_group">
                      <p>
                        {RoutineDetail?.masterLevel?.name
                          ? RoutineDetail?.masterLevel?.name
                          : "-"}
                      </p>
                    </div>
                  </div>

                  {/* <div class="day_time">
                    <div class="entry_title">
                      <p>Category</p>
                      <p>Studio Name</p>
                      <p>Studio Code</p>
                      <p>Age Class</p>
                      <p>Entry Age</p>
                      <p>Level</p>
                    </div>
                    <div class="small_group">
                      <p>
                        {RoutineDetail?.masterMusicCategory?.name
                          ? RoutineDetail?.masterMusicCategory?.name
                          : "-"}
                      </p>
                      <p>
                        {RoutineDetail?.studio_name
                          ? RoutineDetail?.studio_name
                          : "-"}
                      </p>
                      <p>
                        {RoutineDetail?.studio_code
                          ? RoutineDetail?.studio_code
                          : "-"}
                      </p>
                      <p>
                        {RoutineDetail?.masterAgeClass?.name
                          ? RoutineDetail?.masterAgeClass?.name
                          : "-"}
                      </p>
                      <p>
                        {RoutineDetail?.entry_age
                          ? RoutineDetail?.entry_age
                          : "-"}
                      </p>
                      <p>
                        {RoutineDetail?.masterLevel?.name
                          ? RoutineDetail?.masterLevel?.name
                          : "-"}
                      </p>
                    </div>
                  </div> */}
                </div>
              )}
            </div>
            {RoutineDetail?.type === "routine" && (
              <div className="row">
                <div className="col-md-3 col-6">
                  {RoutineDetail &&
                    RoutineDetail?.eventPerformer?.map((_, i) => (
                      <p>Performer {i + 1}</p>
                    ))}
                </div>
                <div className="col-md-6 col-6">
                  <div className="performer_count">
                    {RoutineDetail &&
                      RoutineDetail?.eventPerformer?.map((ele) => (
                        <p>{ele?.performer_name}</p>
                      ))}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoutineDetail;
